import ajax from '../../utils/ajax';
import dom from '../../utils/dom';

function postDocumentTo(path, data = {}) {
  const $form = dom.makeElement('form', { method: 'post', action: path });

  $form.style.display = 'none';

  Object.entries(data).forEach(([name, value]) => {
    $form.appendChild(
      dom.makeElement('input', { type: 'hidden', name, value }),
    );
  });

  document.body.appendChild($form);

  $form.submit();
}

/**
 * @returns {Promise<{isSuccessful: boolean, html: string}>}
 */
async function getPaymentPlanPreview(scheduleId) {
  return ajax.get('/cart/paymentplan/preview', { scheduleId });
}

/**
 * @returns {Promise<{isSuccessful: boolean}>}
 */
function applyPaymentPlan(scheduleId) {
  return ajax.postWwwFormUrlEncoded('/cart/paymentplan/apply', { scheduleId });
}

function removePaymentPlan() {
  postDocumentTo('/cart/paymentplan/remove', {
    __RequestVerificationToken: ajax.getRequestVerificationToken(),
  });
}

export default {
  getPaymentPlanPreview,
  applyPaymentPlan,
  removePaymentPlan,
};
